// RENOMEAR PARA 'conf.js'
const domain = 'https://nssupport.netsupport.com.br/portal/'
export const env = 'prod' // dev, prod, teste
export default domain
export const onboarding = true
